import { Dimensions } from 'editor/src/store/design/types';

// Resolves the physical size (mm) a digitized image should be placed at. The digitized size defines
// how the frame is sized: when both dimensions are known they are used as-is; when only one is
// known the other is derived from the source image aspect ratio. Returns undefined when the size
// cannot be resolved (no digitized dimension known, or no source aspect ratio to derive from).
function getDigitizedSizeMm(
  digitizedSizeMm: Dimensions | undefined,
  { width: imageWidth, height: imageHeight }: Dimensions,
): Dimensions | undefined {
  const mmWidth = digitizedSizeMm?.width;
  const mmHeight = digitizedSizeMm?.height;
  const hasMmWidth = mmWidth !== undefined && mmWidth > 0;
  const hasMmHeight = mmHeight !== undefined && mmHeight > 0;

  if (hasMmWidth && hasMmHeight) {
    return { width: mmWidth, height: mmHeight };
  }

  // deriving the missing dimension requires the source aspect ratio
  const hasImageDimensions = imageWidth > 0 && imageHeight > 0;
  if (!hasImageDimensions) {
    return undefined;
  }

  if (hasMmWidth) {
    return { width: mmWidth, height: (mmWidth * imageHeight) / imageWidth };
  }
  if (hasMmHeight) {
    return { width: (mmHeight * imageWidth) / imageHeight, height: mmHeight };
  }

  return undefined;
}

export default getDigitizedSizeMm;
